import React from 'react'
import FabricInquiryNewDetails from './FabricInquiryNewDetails'

const FabricInquiryNewBody = () => {
  return (
    <div className="view-qualities folded router-view-container">
    <FabricInquiryNewDetails />

</div>
  )
}

export default FabricInquiryNewBody